import { render, staticRenderFns } from "./AdminThingTypes.vue?vue&type=template&id=1dd86020&scoped=true"
import script from "./AdminThingTypes.vue?vue&type=script&lang=js"
export * from "./AdminThingTypes.vue?vue&type=script&lang=js"
import style0 from "./AdminThingTypes.vue?vue&type=style&index=0&id=1dd86020&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd86020",
  null
  
)

export default component.exports